import { ca } from '@cian/analytics';

const MORTGAGE_PVZ_OFFERS_TRAP_EXTRA = {
  trap_type: 'cigar_get_offers_pvz',
  bannerName: 'Получить предложения банков',
  trapid: 'Получить предложения банков',
} as const;

const getMortgagePvzOffersTrapPage = () => ({
  extra: MORTGAGE_PVZ_OFFERS_TRAP_EXTRA,
});

export const trackMortgagePvzOffersButtonShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'show_sopr',
    label: 'mortgage_button',
    page: getMortgagePvzOffersTrapPage(),
  });
};

export const trackMortgagePvzOffersButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'click_sopr',
    label: 'mortgage_button',
    page: getMortgagePvzOffersTrapPage(),
  });
};
